import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Router navigations must start at the top of the new page, not at the previous scroll offset. */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
